import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import LetterHero from './components/LetterHero';
import PainStory from './components/PainStory';
import TheProblemLetter from './components/TheProblemLetter';
import ProgramIntroLetter from './components/ProgramIntroLetter';
import ThePeterLetter from './components/ThePeterLetter';
import DiscoverLetter from './components/DiscoverLetter';
import ImagineLetter from './components/ImagineLetter';
import ValueStackLetter from './components/ValueStackLetter';
import GuaranteeLetter from './components/GuaranteeLetter';
import FinalCTALetter from './components/FinalCTALetter';
import LegalModal from './components/LegalModal';

const { FiX, FiCheck } = FiIcons;

function App() {
  const [modalType, setModalType] = useState(null);

  const dontNeed = [
    'coding skills',
    'marketing expertise',
    'expensive software',
    'inventory',
    'or complicated systems'
  ];

  const simplyNeed = [
    'beginner-friendly guidance',
    'realistic expectations',
    'and simple practical steps'
  ];

  const openModal = (type) => (e) => {
    e.preventDefault();
    setModalType(type);
  };

  return (
    <div className="min-h-screen bg-bg-primary font-sans text-text-primary selection:bg-brand-gold/20 selection:text-brand-dark">
      <LetterHero />
      <PainStory />
      <TheProblemLetter />
      <ProgramIntroLetter />
      <ThePeterLetter />
      <DiscoverLetter />
      <ImagineLetter />

      <section className="bg-bg-alt py-12 border-y border-slate-200">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-5xl font-display font-black text-brand-dark mb-12">
            This Program Was Designed Specifically For Retirees
          </h2>
          <div className="grid md:grid-cols-2 gap-8 text-left">
            {/* Don't Need Column */}
            <div className="bg-white p-10 rounded-[2.5rem] shadow-sm border border-red-100">
              <p className="text-xs font-black uppercase text-red-600 mb-8 tracking-[0.2em]">You do NOT need:</p>
              <ul className="space-y-4">
                {dontNeed.map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-lg font-medium text-text-secondary">
                    <SafeIcon icon={FiX} className="text-red-400 flex-shrink-0" />
                    <span className="line-through decoration-red-300 opacity-60">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Simply Need Column */}
            <div className="bg-brand-green/5 p-10 rounded-[2.5rem] border-2 border-brand-green/20">
              <p className="text-xs font-black uppercase text-brand-green mb-8 tracking-[0.2em]">You simply need:</p>
              <ul className="space-y-4">
                {simplyNeed.map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-lg font-bold text-brand-dark">
                    <div className="flex-shrink-0 w-6 h-6 bg-brand-green rounded-full flex items-center justify-center">
                      <SafeIcon icon={FiCheck} className="text-white text-sm" />
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <p className="mt-16 text-2xl md:text-3xl font-display font-black text-brand-dark">
            That’s exactly what this book delivers.
          </p>
        </div>
      </section>

      <ValueStackLetter />
      <GuaranteeLetter />
      <FinalCTALetter />

      <footer className="bg-bg-alt border-t border-slate-200 py-24 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <p className="text-2xl font-display font-black text-brand-dark mb-10">Simple Online Income For Retirees</p>
          
          <div className="flex flex-wrap justify-center gap-x-10 gap-y-6 text-sm font-bold text-text-secondary uppercase tracking-[0.2em] mb-16">
            <button onClick={openModal('privacy')} className="hover:text-brand-gold transition-colors">Privacy Policy</button>
            <button onClick={openModal('terms')} className="hover:text-brand-gold transition-colors">Terms of Service</button>
            <button onClick={openModal('contact')} className="hover:text-brand-gold transition-colors">Contact Support</button>
          </div>

          <p className="text-slate-400 text-sm mb-6">
            © {new Date().getFullYear()} Simple Online Income. All rights reserved.
          </p>
          <div className="max-w-3xl mx-auto text-[10px] text-slate-300 uppercase tracking-widest leading-loose font-bold">
            Disclaimer: The results mentioned are not typical. We do not guarantee income. Your success depends on your effort and market conditions. This site is not a part of the Facebook website or Facebook Inc.
          </div>
        </div>
      </footer>

      {/* Pop-up Modals */}
      <LegalModal 
        isOpen={modalType !== null} 
        onClose={() => setModalType(null)} 
        type={modalType} 
      />
    </div>
  );
}

export default App;